import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const invoiceApi = createApi({
  reducerPath: "invoiceApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}invoice/`),

  endpoints: (builder) => ({
    getAllInvoice: builder.query({
      query: () => ({
        url: "GetInvoices",
        method: "GET",
      }),
    }),

    getInvoiceById: builder.query({
      query: (invoiceId) => ({
        url: `GetInvoiceById?invoiceId=${invoiceId}`,
        method: "GET",
      }),
    }),

    getInvoicesByLeadId: builder.query({
      query: (leadId) => ({
        url: `GetInvoicesByLeadId?leadId=${leadId}`,
        method: "GET",
      }),
    }),

    useLazyGetInvoiceByIdQuery: builder.query({
      query: (leadId) => ({
        url: `GetInvoicesByLeadId?leadId=${leadId}`,
        method: "GET",
      }),
    }),

    addInvoice: builder.mutation({
      query: (body) => {
        return {
          url: "AddInvoice",
          method: "POST",
          body,
        };
      },
    }),

    updateInvoiceStatus: builder.mutation({
      query: ( body ) => {
        return {
          url: "UpdateInvoiceStatus",
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useAddInvoiceMutation,
  useGetAllInvoiceQuery,
  useLazyGetInvoiceByIdQuery,
  useGetInvoiceByIdQuery,
  useUpdateInvoiceStatusMutation,
  useGetInvoicesByLeadIdQuery
} = invoiceApi;

export default invoiceApi.reducer;
